/**************************************************
 * Nombre:       Letra_Titulo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useEffect} from "react";

const Letra_Titulo = ({numero, titulo, grande=false }) => {

    useEffect(() => {

    },[numero])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: grande ? 18 : 16}}>{titulo}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: grande ? 40 : 32, fontWeight: 600, lineHeight: 1.2}}>{numero}</Typography>
            </Grid>



        </Grid>
    )

}
export default Letra_Titulo